import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, Subject, } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
@Injectable({
    providedIn: 'root'
})
export class eligibility270Service extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public outputValues(state): void {
        this.getList(state).subscribe(x => super.next(x));
    }
    getList(state?): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/ClaimProcess/Get270Datas", state)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))


    }

}
